import { render, staticRenderFns } from "./PxCamposCompraProjedata.vue?vue&type=template&id=527d1600&"
import script from "./PxCamposCompraProjedata.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraProjedata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports